<template>
  <div class="wrap">
    <div v-wechat-title="$route.meta.title=title"></div>
    <div v-html="content"></div>
  </div>
</template>
<script>
import { getManagement } from '@/api/app'
export default {
  data(){
    return{
      content:'',
      title:''
    }
  },
  methods:{
    getList(language){
      const postarr ={
        titleZh:'用户协议',
        language: language||'zh'
      }
      getManagement(postarr).then(res=>{
        this.title = res.titleMultilingual
        this.content = res.content
      })
    }
  },
  mounted(){
    const { query } = this.$route;
    const { language } = query;
    this.getList(language)
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  // max-width: 750PX;
  margin: 0 auto;
  font-size: 28px;
  padding: 25px;
}
</style>